import React from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";

export const FaqBlock = ({ items, title = "Frequently asked questions", testId = "faq-block" }) => {
  if (!items?.length) return null;
  return (
    <section className="mt-20" data-testid={testId}>
      <p className="eyebrow text-[#C9B79C] mb-3">Good to know</p>
      <h2 className="font-display font-light text-3xl md:text-4xl text-[#F3EEE3] mb-6">{title}</h2>
      <Accordion type="single" collapsible className="w-full">
        {items.map((f, i) => (
          <AccordionItem key={i} value={`q-${i}`} className="border-[#F3EEE3]/12" data-testid={`${testId}-item-${i}`}>
            <AccordionTrigger className="text-[#F3EEE3] text-base md:text-lg font-display font-normal hover:no-underline py-5 text-left">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#F3EEE3]/70 text-sm leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export const faqLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});
